import { ITimezone } from 'app/services/constants';
import Tooltip from 'Components/Tooltips';
import { ReactNode } from 'react';

export default function Timezone({
  value,
  fallback = '',
}: {
  value?: ITimezone;
  fallback?: ReactNode | string;
}) {
  return (
    <Tooltip
      message={
        value && (
          <div className="text-center">
            <div>{value?.value}</div>
            <div className="text-xs">{value?.text}</div>
          </div>
        )
      }
    >
      <div className="line-clamp-1">
        <div>{value?.abbr || fallback}</div>
      </div>
    </Tooltip>
  );
}
